exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resume-section-item-container .item-body .item-body-title[data-v-50282bb2]{font-weight:600;line-height:30px}.resume-section-item-container .item-body li[data-v-50282bb2]{margin:0 30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50282bb2","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/about/resume-section-item.vue
// module id = 210
// module chunks = 0